import React, { Component } from 'react'
import { t } from 'i18n'
import axios from 'axios'

class ArticleCardsBlock extends Component {
  constructor(props) {
    super(props)
    this.state = {
      articles: JSON.parse(props.passedArticles),
      isLoading: false
    }
    this.skippableArticleId = props.skippableArticleId || null

    this.fetchMoreArticles = this.fetchMoreArticles.bind(this)
  }
  articlesParams() {
    const { articles } = this.state
    return {
      offset_id: articles[articles.length -1].id,
      skippable_article_id: this.skippableArticleId
    }
  }

  articleMaxCount() {
    if(this.skippableArticleId) {
      // Means that one article is in show mode and
      // should not be displayed in cards
      return this.props.totalCount - 1
    } else {
      return this.props.totalCount
    }
  }
  fetchMoreArticles() {
    const { articles } = this.state

    this.setState({isLoading: true})
    axios.get(`/articles.json`, { params: this.articlesParams() }).then( (response) => {
      if (response.status == 200){
        let newArticles = articles
        for(let article of response.data) {
          newArticles.push(article)
        }
        this.setState({articles: newArticles})
      }
      this.setState({isLoading: false})
    })
  }

  renderArticle(article) {
    return(
      <div className='col-lg-4 col-md-6 mb-4 custom-card' key={article.id}>
        <a href={article.url} className='content-card'>
          <img src={article.thumb_image_url} alt='' className='content-card-image' />
          <h3 className='content-card-title'>{article.title}</h3>
        </a>
      </div>
    )
  }

  renderReadMoreButton() {
    if(this.props.noMoreButton || this.state.articles.length == this.articleMaxCount()) {
     return
    }
    if(this.state.isLoading){
      return(
        <div className='row'>
          <div className='text-center col-12'>
            <span className='loading-indicator'></span>
          </div>
        </div>
      )
    } else {
      return (
        <div className='row'>
          <div className='text-center col-12'>
            <button type='button' onClick={this.fetchMoreArticles} className='btn btn-outline btn-lg mt-4 mb-5'>
              {t('main.articles.more')}
            </button>
          </div>
        </div>
      )
    }
  }

  render() {
    const articles = this.state.articles.map(article => this.renderArticle(article))

    return(
      <div id='articles-cards'>
        <div className='row'>
          {articles}
        </div>
        {this.renderReadMoreButton()}
      </div>
    )
  }
}

export default ArticleCardsBlock
